export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/report_shield_icon.a5b809b4.svg","height":32,"width":37,"blurWidth":0,"blurHeight":0};